module.exports = __webpack_public_path__ + "static/img/84097B_1_C_20210225_fit.2437b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84097B_1_C_20210225_fit.png
// module id = w9H+
// module chunks = 0